import { render, staticRenderFns } from "./GuideDeleteAccount.vue?vue&type=template&id=5b7fc7c4"
import script from "./GuideDeleteAccount.vue?vue&type=script&lang=js"
export * from "./GuideDeleteAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports